// mixpanel-browser keeps a tracking opt-out under this prefix plus the project
// token. Clearing it re-enables Mixpanel until the next page load: the iOS
// build is opted out by default (utils/mixpanel-options.js), and a clear on the
// way to a redirect let the next event out. Like the session-recording choice,
// an opt-out belongs to the browser, not the session, so every clear keeps it.
const MIXPANEL_OPT_OUT_PREFIX = '__mp_opt_in_out_';

const mixpanelOptOutKeys = (storage) => {
  const keys = [];
  try {
    for (let index = 0; index < storage.length; index += 1) {
      const key = storage.key(index);
      if (key && key.startsWith(MIXPANEL_OPT_OUT_PREFIX)) {
        keys.push(key);
      }
    }
  } catch (_) {
    // Blocked storage has nothing to keep.
  }
  return keys;
};

export const clearLocalStoragePreservingKeys = (storage, keysToPreserve) => {
  const snapshots = {};

  [...keysToPreserve, ...mixpanelOptOutKeys(storage)].forEach((key) => {
    try {
      const value = storage.getItem(key);
      if (value !== null) {
        snapshots[key] = value;
      }
    } catch (_) {
      // Redirect and logout flows should continue even when storage is blocked.
    }
  });

  storage.clear();

  Object.entries(snapshots).forEach(([key, value]) => {
    try {
      storage.setItem(key, value);
    } catch (_) {
      // Redirect and logout flows should continue even when storage is blocked.
    }
  });
};
